import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { componentDidCatch } from 'Global/Stores/errors'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapDispatchToProps = (dispatch, ownProps) => ({
    sendError: error => dispatch(componentDidCatch(error)),
  })

  Enhancer.displayName = 'ErrorLoggerEnhancer'

  Enhancer.propTypes = {
    sendError: PropTypes.func.isRequired,
  }

  return connect(
    null,
    mapDispatchToProps,
  )(Enhancer)
}
